module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow-5f13fc62178b308ae4b88c872120e33d.webp";